<template>
	<div class="laycontainer page_wrapper">
		<div class="sidebar">
			<div class="mod_title"><span class="title">用户指南</span></div>
			<div class="mod_menu" v-loading="treeLoading">
				<el-tree ref="tree" @node-click="nodeClick" :data="treeData" default-expand-all node-key="id" highlight-current :props="defaultProps" :expand-on-click-node="false">
					<p slot-scope="{ node }" class="custom-tree-node" style="width: 141px; line-height: 13px">
						<span :title="node.label" class="ellipsis" :style="{ width: node.data.type == 1 ? '133px' : '115px', display: 'inline-block' }">{{ node.label }}</span>
					</p>
				</el-tree>
			</div>
		</div>
		<div class="mainbar">
			<div class="m_breadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><img class="home_img" src="@/assets/img/home.png" alt="" />首页</el-breadcrumb-item>
					<el-breadcrumb-item>{{ pName }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ cName }}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="main_content" v-loading="listLoading" v-html="content || '暂无指南'"></div>
		</div>
	</div>
</template>
  
<script>
export default {
	data() {
		return {
			treeLoading: false,
			currentPid: '',
			treeData: [],
			defaultProps: {
				children: 'childrenList',
				label: 'title',
			},
			listLoading: false,
			content: '',
			pName: '',
			cName: '',
		}
	},
	created() {
		this.getTree()
	},
	methods: {
		nodeClick(node) {
			console.log(node, 'noddddddddd')

			this.$nextTick(() => {
				this.$refs.tree.setCurrentKey(this.currentPid) //当前选中不变
			})
			// if (node.type == '1') return

			if (node.type == '1') {
				console.log(1)
			} else {
				this.pName = this.treeData.filter(v => v.id == node.pid)[0].title
			}

			this.cName = node.title
			this.currentPid = node.id
			this.getDataList()
		},
		getTree() {
			this.treeLoading = true
			this.$http
				.post(this.$api.systemApi.listTree, { type: '' })
				.then(({ data }) => {
					this.treeLoading = false
					this.treeData = data.data
					this.currentPid = data.data && data.data.length > 0 && data.data[0].childrenList ? data.data[0].childrenList[0].id : ''
					// this.currentPid = data.data && data.data.length > 0  ? data.data[0].id : ''
					if (this.currentPid) {
						let node = data.data[0].childrenList[0]
						// let node = data.data[0]
						this.pName = this.treeData.filter(v => v.id == node.pid)[0].title
						this.cName = node.title
						this.getDataList()
					}
					this.$nextTick(() => {
						this.$refs.tree.setCurrentKey(this.currentPid)
					})
				})
				.catch(() => {
					this.treeLoading = false
					this.treeData = []
				})
		},
		// 获取列表
		getDataList() {
			this.listLoading = true
			let params = {
				current: '1',
				size: '1',
				data: {
					pid: this.currentPid,
					title: '',
				},
			}
			this.$http
				.post(this.$api.systemApi.guideList, params)
				.then(({ data }) => {
					let arr = data.data.list
					this.content = arr && arr.length > 0 ? arr[0].content : '' //每个二级分类下的指南只有一个
					this.listLoading = false
				})
				.catch(() => {
					this.listLoading = false
					this.content = ''
				})
		},
	},
}
</script>
  

<style lang="scss" scoped>
.laycontainer {
	display: flex;
}

.sidebar {
	width: 208px;
	background: #fff;
	// height: calc(100vh - 168px);
	min-height: calc(100vh - 168px);
	margin-top: 16px;
	margin-bottom: 16px;
	box-shadow: 0px 2px 24px 1px rgba(0, 0, 0, 0.06);
	border-radius: 16px;

	.mod_title {
		padding: 14px 16px;
		border-bottom: 1px solid #dcdcdc66;

		.title {
			padding-left: 14px;
			font-size: 16px;
			font-weight: bold;
			color: #2962b0;
			border-left: 2px solid #2962b0;
		}
	}

	.mod_menu {
		padding: 16px;

		.menu_list {
			li {
				height: 40px;
				line-height: 40px;
				text-align: center;
				margin-bottom: 8px;
				background: rgba(51, 51, 51, 0.04);
				font-size: 16px;
				font-weight: bold;
				color: #333;
				border-radius: 8px;
				cursor: pointer;

				&:hover {
					background: #eff7ff;
					color: #2962b0;
				}

				&.active {
					background: #eff7ff;
					color: #2962b0;
				}
			}
		}
	}
}

.mainbar {
	flex: 1;
	// height: calc(100vh - 320px);
	min-height: calc(100vh - 168px);
	background: #fff;
	margin-top: 16px;
	box-shadow: 0px 2px 24px 1px rgba(0, 0, 0, 0.06);
	margin-left: 16px;
	margin-bottom: 16px;
	border-radius: 16px;
	position: relative;
	overflow: hidden;

	.m_breadcrumb {
		padding: 14px 30px;
		border-bottom: 1px solid #f1f1f1;

		.home_img {
			margin-right: 6px;
			height: 14px;
			margin-top: -4px;
		}
	}

	.main_content {
		padding: 20px 30px;
		overflow: auto;
		height: calc(100% - 43px);
		// text-align: center;
		// padding-top: 100px;
	}
}

.mod_menu {
	height: calc(100% - 47px);
	overflow: auto;
}

.el-tree > .el-tree-node > .el-tree-node__content > p {
	font-weight: 700;
}

::v-deep .el-tree-node__content {
	height: 32px;
}
</style>
  